
import { useBooks, useLayout, useMap } from "@/services";
import { BookStatusEntry, BookStatus, BottomTab } from "@/types";
import { formatDate } from "@/util/helpers";
import { computed, defineComponent, onMounted, onUnmounted } from "vue";

export default defineComponent({
  components: {},
  props: {
    book: {
      type: Object as () => BookStatusEntry,
      required: true,
    },
  },
  setup(props) {
    const bookStore = useBooks();
    const mapStore = useMap();

    const book = computed(() => props.book);
    const isActive = computed({
      get() {
        return mapStore.isBookLoaded(book.value);
      },
      set(active: boolean) {
        if (active && !mapStore.isBookLoaded(book.value)) {
          mapStore.loadBook(book.value);
          useLayout().setBottomActiveTab(BottomTab.Query, true);
        } else {
          mapStore.unloadBook(book.value);
        }
      },
    });
    const completedStatuses = new Set([BookStatus.Success, BookStatus.Failure]);
    let pollIntervalId: any;

    onMounted(() => mounted());
    onUnmounted(() => stopPolling());

    function mounted() {
      if (completedStatuses.has(book.value.statusId)) {
        return;
      }
      pollIntervalId = setInterval(() => pollStatus(), 5000);
    }

    async function pollStatus() {
      const latest = await bookStore.reloadBookStatus(
        book.value.userId,
        book.value.id
      );

      if (latest && completedStatuses.has(latest.statusId)) {
        stopPolling();
      }
    }

    function stopPolling() {
      if (pollIntervalId) {
        clearInterval(pollIntervalId);
      }
    }

    function getIcon(status: BookStatus): string {
      if (checkIfProcessing(status)) {
        return "arrow-repeat";
      }

      return status === BookStatus.Failure ? "exclamation-triangle" : "";
    }

    function checkIfProcessing(status: BookStatus): boolean {
      return !(status === BookStatus.Success || status === BookStatus.Failure);
    }
    return {
      BookStatus,
      isActive,
      formatDate,
      getIcon,
    };
  },
  methods: {
    async deleteBook(book) {
      try {
        const value = await this.$bvModal.msgBoxConfirm(
          "Are you sure want to delete " + [book.name] + "?",
          {
            title: "Delete confirmation",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        );
        if (value) {
          await useBooks().deleteBook(book);
          this.$root.$bvToast.toast("Book deleted sucessfully", {
            title: "Deleted",
            variant: "success",
            solid: true,
          });
        }
      } catch (err) {
        // An error occurred
        this.$root.$bvToast.toast(`Failed to delete ${book.name}`, {
          title: "Deletion failed",
          variant: "danger",
          solid: true,
        });

        console.error(err);
      }
    },
  },
});
